export default __webpack_public_path__ + "59cfc3a830818afe3a805bf61c77de00.png";